export default class AuthenticationForm {
  constructor(currentScheme) {
    this.currentScheme = currentScheme
  }

  init() {
    this.updateAuthenticationFormFieldsRequirement()

    document
      .querySelectorAll("input[type=radio]")
      .forEach(input => (input.onchange = this.updateAuthMethod.bind(this)))

    document.querySelector(
      "form.service-edit-authentication"
    ).onsubmit = this.validateForm.bind(this)
  }

  updateAuthenticationFormFieldsRequirement() {
    document.querySelectorAll("[data-required-if-visible]").forEach(elem => {
      // jQuery.visible is a jQuery extension and could not cannot take advantage of querySelectorAll.
      // Using same logic from https://github.com/jquery/jquery/blob/b2bbaa36d4d37bd48f954ed3cdbd50d3461a523d/src/css/hiddenVisibleSelectors.js
      const visible =
        elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length

      visible
        ? elem.setAttribute("required", "required")
        : elem.removeAttribute("required")
    })
  }

  updateAuthMethod(elem) {
    if (elem.target.value === "no_oauth") {
      document.querySelector(".oauth-fields").style.display = "none"
    } else {
      document.querySelector(".oauth-fields").style.display = "block"
    }

    this.updateAuthenticationFormFieldsRequirement()
  }

  validateForm(event) {
    const newScheme = document.querySelector("input[type=radio]:checked").value

    if (this.currentScheme === newScheme) return true

    const confirm = window.confirm(this.confirmationDialogMessage(newScheme))

    if (confirm) {
      return true
    } else {
      event.preventDefault()
      event.stopPropagation()()
      return false
    }
  }

  // confirmationDialogMessage just run when scheme changed
  confirmationDialogMessage(newScheme) {
    let warningMessage = ""
    const bullets = []

    if (this.currentScheme === "no_oauth") {
      warningMessage =
        "By changing your service from non-authenticated to authenticated:"
    } else if (newScheme === "no_oauth") {
      warningMessage = "By disabling authentication:"
    } else if (
      this.currentScheme === "standard_auth" &&
      newScheme === "refresh_auth"
    ) {
      warningMessage = "By enabling refresh token support:"
    } else if (
      this.currentScheme === "refresh_auth" &&
      newScheme == "standard_auth"
    ) {
      warningMessage = "By disabling refresh token support:"
    }

    if (this.currentScheme === "standard_auth") {
      bullets.push("Users' access tokens will be removed.")
    } else {
      bullets.push("Users' access and refresh tokens will be removed.")
    }

    bullets.push("Users will need to re-activate the service.")
    bullets.push("All existing Applets for your service will be deleted.")

    return [
      warningMessage,
      bullets.map(b => "• " + b).join("\n"),
      "Do you wish to proceed with the authentication changes?",
    ].join("\n\n")
  }
}
